<template>
    <div>
        <label
            v-if="label"
            :for="id"
            class="block font-medium"
        >
            {{ label }}
            <span
                class="text-red-500"
                v-if="vuelidate.required"
            >
                    *
                </span>
        </label>
        <ckeditor
            :id="id"
            :editor="editor"
            v-model="content"
            v-on:input="updateEditor"
            :config="editorConfig"
            tag-name="textarea"
        ></ckeditor>
    </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
    props: {
        vuelidate: {
            type: String,
            default: () => '',
        },
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: () => "",
        },
        placeholder: {
            type: String,
            default: () => "",
        },
        update: {
            type: Function,
            required: true,
        }
    },
    data() {
        return {
            content: '',
            editDesc: '',
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "blockQuote"
                ]
            },
        }
    },
    mounted () {
        console.log('vuelidate', this.vuelidate)
        this.$nextTick(function () {
            this.content = this.vuelidate;

        });

    },

    methods: {
        updateEditor (content) {
            this.update(this.id, content);
        }
    }
}
</script>
